import * as S from './styles';
import React from 'react';
import theme from '../../../../../global/styles/theme';
import TextDefault from '../../../../../components/TextDefault';
import Button from '../../../../../components/Button';
import Input from '../../../../../components/Input';
import {useForm} from 'react-hook-form';
import {yupResolver} from '@hookform/resolvers/yup';
import {useState} from 'react';
import {recoverPassword} from '../../../../../services/auth';
import Toast from 'react-native-toast-message';
import {toastConfig} from '../../../../../components/Toast';
import {schemaRecover} from '../../../../../utils/schema';
import KeyboardScrollView from '../../../../../components/KeyboardScrollView';
import {StatusBarContainer} from '../../../../../components/StatusBar';
import {useNavigation} from '@react-navigation/native';
import {RootState} from '../../../../../store';
import {useSelector} from 'react-redux';

const recoverResolver = {
  resolver: yupResolver(schemaRecover),
};

export default function ChangePasswordScreen() {
  const {
    control,
    handleSubmit,
    setValue,
    formState: {errors},
  } = useForm(recoverResolver);
  const navigation: any = useNavigation();
  const appTheme = useSelector((state: RootState) => state.config.appTheme);

  const [isLoading, setIsLoading] = useState(false);

  async function handleRecoverPress(data: any) {
    setIsLoading(true);
    await recoverPassword(data)
      .then(async recoverInfo => {
        setIsLoading(false);
        setValue('document', '');
        Toast.show({
          type: 'success',
          text1: recoverInfo?.data?.message || 'Nova senha enviada.',
        });
      })
      .catch(error => {
        setIsLoading(false);
        Toast.show({
          type: 'error',
          text1:
            error?.response?.data?.message ||
            'Ocorreu um erro, tente novamente mais tarde!',
        });
      });
  }

  return (
    <>
      <StatusBarContainer />
      <S.Container appTheme={appTheme}>
        <S.ContainerArea appTheme={appTheme}>
          <KeyboardScrollView justifyContent="flex-start">
            <S.Body>
              <S.Row>
                <S.ButtonGoBack onPress={() => navigation.goBack()}>
                  <S.IconImage
                    color={theme.colors(appTheme).white}
                    size={26}
                    name="arrow-left"
                  />
                </S.ButtonGoBack>
                <TextDefault
                  fontSize={20}
                  color={theme.colors(appTheme).white}
                  text="Recuperar senha"
                  fontFamily={theme.fonts.family.opensans.semi_bold}
                />
                <S.IconImage color="transparent" size={32} name="arrow-left" />
              </S.Row>
              <S.Column>
                <Input
                  title="CPF/CNPJ"
                  errors={errors}
                  placeholder="Digite seu cpf/cnpj"
                  control={control}
                  name="document"
                  width="100%"
                  marginTop={10}
                  hideBorder
                  mask="cpfOrCnpj"
                  keyboardType="phone-pad"
                />
              </S.Column>
              <Button
                title="RECUPERAR"
                onPress={handleSubmit(handleRecoverPress)}
                fontFamily={theme.fonts.family.opensans.bold}
                marginTop={40}
                marginBottom={40}
                isLoading={isLoading}
                width="90%"
              />
            </S.Body>
          </KeyboardScrollView>
        </S.ContainerArea>
        <Toast config={toastConfig} />
      </S.Container>
    </>
  );
}
